document.addEventListener("DOMContentLoaded", () => {

  const EAST_DEBUG = true;
  const log  = (...a) => EAST_DEBUG && console.log("[EastColProd]", ...a);
  const warn = (...a) => EAST_DEBUG && console.warn("[EastColProd]", ...a);

  const section = document.querySelector(".east-col-prod-section");
  if (!section) { warn("section not found"); return; }

  const cfg = {
    circleAutoScroll : section.dataset.autoScroll     === "true",
    circleScrollSpeed: parseFloat(section.dataset.scrollSpeed)     || 3,
    hoverPause       : section.dataset.hoverPause     === "true",
    dragScroll       : section.dataset.dragScroll     === "true",
    infiniteLoop     : section.dataset.infinite       === "true",
    alwaysCta        : section.dataset.alwaysCta      === "true",
    prodShowArrows   : section.dataset.prodShowArrows === "true",
    prodDrag         : section.dataset.prodDrag       === "true",
    prodAutoScroll   : section.dataset.prodAutoScroll === "true",
    prodScrollSpeed  : parseFloat(section.dataset.prodScrollSpeed) || 3,
    prodHoverPause   : section.dataset.prodHoverPause === "true",
  };

  let circleLoopWidth = 0;
  let prodLoopWidth   = 0;

  // Shared offset state for transform-based scrolling
let circleOffset = 0;
let prodOffset   = 0;

function setupInfinite(track, type) {
  if (!track) return;

  track.querySelectorAll(".is-clone").forEach(el => el.remove());

  const children = Array.from(track.children);
  if (!children.length) return;

  // Get the CSS gap value from the track's computed style
  const trackStyle = window.getComputedStyle(track);
  const gapValue = parseFloat(trackStyle.gap || trackStyle.columnGap || "0") || 0;

  const totalWidth = children.reduce((acc, el, i) => {
    const style = window.getComputedStyle(el);
    const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    // Add gap for all items except the last
    const gap = i < children.length - 1 ? gapValue : 0;
    return acc + el.offsetWidth + margin + gap;
  }, 0);

  // Add one gap at the end (the gap between last original and first clone)
  const loopWidth = totalWidth + gapValue;

  if (type === "circle") circleLoopWidth = loopWidth;
  if (type === "prod")   prodLoopWidth   = loopWidth;

  // Clone items for infinite effect
  children.forEach(el => {
    const clone = el.cloneNode(true);
    clone.classList.add("is-clone");
    track.appendChild(clone);
  });

  track.style.willChange = "transform";
}

  // Direct speed mapping - higher number = faster
  const getSpeed = (speedValue) => {
    // Speed values: 1 (slowest) to 10 (fastest)
    // Convert to pixels per frame (60fps)
    const minSpeed = 0.6;  // pixels per frame at speed 1
    const maxSpeed = 3;    // pixels per frame at speed 10
    return minSpeed + ((speedValue - 1) / 9) * (maxSpeed - minSpeed);
  };

  const CIRCLE_SPEED = getSpeed(cfg.circleScrollSpeed);
  const PROD_SPEED = getSpeed(cfg.prodScrollSpeed);

  let data = { collections: [], cart_icon: "", always_cta: false };
  try {
    const el = section.querySelector("#eastCollectionData");
    if (el) data = JSON.parse(el.textContent);
  } catch(e) { warn(e); }

  const colMap = Object.fromEntries(data.collections.map(c => [c.handle, c]));

  const circleTrack  = section.querySelector("#eastCircles");
  const prodTrack    = section.querySelector(".eastTrack");
  const progressWrap = section.querySelector(".eastProgress");
  const ctaWrapper   = section.querySelector("#eastCTAWrapper");
  const ctaLink      = section.querySelector("#eastCTA");

  function renderCard(p) {
    let badge = "";
    if (p.best_seller === true) {
      badge = "Best Seller";
    }
    if (!badge && p.tags) {
      if (
        p.tags.includes("best-seller") ||
        p.tags.includes("Best Seller") ||
        p.tags.includes("bestseller")
      ) {
        badge = "Best Seller";
      }
    }

    const price = Number(p.price_raw || 0);
    const compare = Number(p.compare_at_price || 0);
    let hasCompare = false;
    let savePct = 0;
    if (compare > price && compare > 0) {
      hasCompare = true;
      savePct = Math.round(((compare - price) * 100) / compare);
    }

    const icon = data.cart_icon
      ? `<img src="${data.cart_icon}" alt="" width="20" height="20">`
      : `<svg viewBox="0 0 24 24" fill="none" width="18" height="18">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <path d="M16 10a4 4 0 0 1-8 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;

    const reviewHtml = p.review_html || "";
    const isAvailable = p.available !== false;

    return `
<div class="east-col-prod-card">
  <div class="east-col-prod-img">
    <a href="${p.url}" class="east-col-prod-img-link" aria-label="${p.title}">
      ${p.image ? `<img src="${p.image}" alt="${p.title}" loading="lazy" width="600">` : `<div class="east-col-prod-img-placeholder"></div>`}
    </a>
    ${badge ? `<span class="east-col-prod-badge">${badge}</span>` : ""}
  </div>
  <div class="east-prod-sec-container">
    <div class="east-col-prod-reviews">${reviewHtml}</div>
    <h3 class="east-col-prod-title">
      <a href="${p.url}" style="color:inherit;text-decoration:none;">${p.title}</a>
    </h3>
    <div class="east-col-prod-price">
      <div class="east-col-prod-price-tag">
        ${hasCompare ? `<span class="east-col-prod-save-badge">SAVE ${savePct}%</span>` : ""}
        <span class="east-col-prod-price-current">${p.price}</span>
        ${hasCompare ? `<span class="east-col-prod-compare">${p.compare_at_price_formatted}</span>` : ""}
      </div>
      ${isAvailable ? `
        <form method="post" action="/cart/add" class="east-col-atc-form js-prod-form-submit" data-product-id="${p.id}">
          <input type="hidden" name="id" value="${p.variant_id}">
          <input type="hidden" name="quantity" value="1">
          <button type="submit" class="east-col-prod-cart add AddtoCart js-ajax-submit" data-product-id="${p.id}" data-variant-id="${p.variant_id}" aria-label="Add ${p.title} to cart">
            ${icon}
          </button>
        </form>
      ` : ""}
    </div>
  </div>
</div>`;
  }

  function buildProgressBars(count) {
    if (!progressWrap) return;
    const track = progressWrap.querySelector(".east-col-prod-progress-track");
    if (!track) return;
    track.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const b = document.createElement("div");
      b.className = "east-col-prod-progress-bar";
      if (i === 0) b.classList.add("active");
      track.appendChild(b);
    }
  }

  function updateCTA(col) {
    if (!ctaWrapper || !ctaLink) return;
    ctaLink.href = col.url || "#";
    const show = cfg.alwaysCta || data.always_cta || col.count > 4;
    ctaWrapper.classList.toggle("east-col-prod-cta--hidden", !show);
  }

  let progressScrollListener = null;

function initProgressBar() {
  if (!prodTrack || !progressWrap) return;

  // Remove old scroll listener
  if (progressScrollListener) {
    prodTrack.removeEventListener("scroll", progressScrollListener);
    progressScrollListener = null;
  }

  const barTrack = progressWrap.querySelector(".east-col-prod-progress-track");
  if (!barTrack) return;

  const cards = Array.from(prodTrack.querySelectorAll(".east-col-prod-card:not(.is-clone)"));
  if (!cards.length) { progressWrap.style.display = "none"; return; }

  // Card width + gap = one scroll "step"
  const gap = parseFloat(getComputedStyle(prodTrack).gap) || 0;
  const cardW = cards[0].offsetWidth + gap;
  const viewportW = prodTrack.offsetWidth;

  // How many cards fit fully in viewport?
  const visibleCount = Math.max(1, Math.floor((viewportW + gap) / cardW));

  // Scrollable steps = total cards - visible cards
  // Each step = scrolling by one card width
  const scrollableSteps = cards.length - visibleCount;

  // If nothing scrolls (all cards visible), hide progress bar
  if (scrollableSteps <= 0) {
    progressWrap.style.display = "none";
    return;
  }

  progressWrap.style.display = "";   // ensure visible

  // Number of dots = scrollableSteps + 1  (includes the "start" position)
  const dotCount = scrollableSteps + 1;

  barTrack.innerHTML = "";
  for (let i = 0; i < dotCount; i++) {
    const b = document.createElement("div");
    b.className = "east-col-prod-progress-bar" + (i === 0 ? " active" : "");
    barTrack.appendChild(b);
  }

  const bars = barTrack.querySelectorAll(".east-col-prod-progress-bar");

  // Update active dot on scroll
  progressScrollListener = () => {
    const scrollIndex = Math.min(
      Math.round(prodTrack.scrollLeft / cardW),
      bars.length - 1
    );
    bars.forEach((b, i) => b.classList.toggle("active", i === scrollIndex));
  };
  prodTrack.addEventListener("scroll", progressScrollListener, { passive: true });

  // Click dot → scroll to that position
  bars.forEach((bar, i) => {
    bar.addEventListener("click", () => {
      prodTrack.scrollTo({ left: i * cardW, behavior: "smooth" });
    });
  });
}

  function swapProducts(handle) {
    const col = colMap[handle];
    if (!col || !prodTrack) return;
    prodTrack.innerHTML = col.products.map(renderCard).join("");
    prodTrack.scrollLeft = 0;
    buildProgressBars(col.products.length);
    updateCTA(col);
    if (cfg.prodAutoScroll) {
      stopProdScroll();
      startProdScroll();
    }
    setTimeout(() => {
      initProgressBar();
      document.dispatchEvent(new Event('vitals:reload'));
    }, 50);
  }

  circleTrack?.addEventListener("click", e => {
    const el = e.target.closest(".east-col-prod-circle");
    if (!el) return;
    document.querySelectorAll(".east-col-prod-circle").forEach(c => c.classList.remove("active"));
    el.classList.add("active");
    swapProducts(el.dataset.handle);
  });

  // CIRCLE DRAG SCROLL
(function attachCircleDrag() {
  if (!circleTrack) return;
  let isDown = false, startX = 0, dragStartOffset = 0, moved = false;
  const DRAG_THRESHOLD = 6;

  function onPointerDown(e) {
    if (e.button !== undefined && e.button !== 0) return;
    isDown = true;
    moved = false;
    startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    dragStartOffset = circleOffset;
    circlePaused = true;
    circleTrack.style.cursor = "grabbing";
    circleTrack.style.userSelect = "none";
  }

  function onPointerMove(e) {
    if (!isDown) return;
    const clientX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const delta = startX - clientX;
    if (!moved && Math.abs(delta) > DRAG_THRESHOLD) moved = true;
    if (moved) {
      circleOffset = dragStartOffset + delta;
      if (circleLoopWidth > 0) {
        circleOffset = ((circleOffset % circleLoopWidth) + circleLoopWidth) % circleLoopWidth;
      }
      circleTrack.style.transform = `translateX(${-circleOffset}px)`;
      e.preventDefault();
    }
  }

  function onPointerUp() {
    if (!isDown) return;
    isDown = false;
    circleTrack.style.cursor = "";
    circleTrack.style.userSelect = "";
    if (cfg.circleAutoScroll) circlePaused = false;
  }

  circleTrack.addEventListener("mousedown", onPointerDown);
  document.addEventListener("mousemove", onPointerMove);
  document.addEventListener("mouseup", onPointerUp);
  circleTrack.addEventListener("touchstart", onPointerDown, { passive: true });
  circleTrack.addEventListener("touchmove", onPointerMove, { passive: false });
  circleTrack.addEventListener("touchend", onPointerUp, { passive: true });
  circleTrack.addEventListener("click", e => {
    if (moved) { e.stopPropagation(); moved = false; }
  }, true);
})();

  let circleRaf = null, circlePaused = false;
  let circleAnimationId = null;

function startCircleScroll() {
  if (!cfg.circleAutoScroll || !circleTrack) return;
  let lastTime = performance.now();
  circleTrack.style.willChange = 'transform';

  function animateScroll(currentTime) {
    if (!circlePaused && circleLoopWidth > 0) {
      const deltaTime = Math.min(33, currentTime - lastTime);
      circleOffset += CIRCLE_SPEED * (deltaTime / 16.67);
      if (circleOffset >= circleLoopWidth) circleOffset -= circleLoopWidth;
      circleTrack.style.transform = `translateX(${-circleOffset}px)`;
    }
    lastTime = currentTime;
    circleAnimationId = requestAnimationFrame(animateScroll);
  }
  circleAnimationId = requestAnimationFrame(animateScroll);
}

  function stopCircleScroll() {
    if (circleAnimationId) {
      cancelAnimationFrame(circleAnimationId);
      circleAnimationId = null;
    }
  }

  let prodRaf = null, prodPaused = false;
  let prodAnimationId = null;

  function isMobile() { return window.innerWidth < 768; }

function startProdScroll() {
  if (!cfg.prodAutoScroll || !prodTrack || !isMobile()) return;

  let lastTime = performance.now();
  prodTrack.style.willChange = 'transform';

  function animateProdScroll(currentTime) {
    if (!prodPaused && prodLoopWidth > 0) {
      const deltaTime = Math.min(33, currentTime - lastTime);
      prodOffset += PROD_SPEED * (deltaTime / 16.67);
      if (prodOffset >= prodLoopWidth) prodOffset -= prodLoopWidth;
      prodTrack.style.transform = `translateX(${-prodOffset}px)`;
    }
    lastTime = currentTime;
    prodAnimationId = requestAnimationFrame(animateProdScroll);
  }
  prodAnimationId = requestAnimationFrame(animateProdScroll);
}

  function stopProdScroll() {
    if (prodAnimationId) {
      cancelAnimationFrame(prodAnimationId);
      prodAnimationId = null;
    }
  }

  // ATC handler
  section.addEventListener("click", async e => {
    const btn = e.target.closest(".east-col-prod-cart");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const vid = btn.dataset.variantId;
    if (!vid) { warn("No variant ID on button"); return; }
    btn.disabled = true;
    log("ATC clicked, variant:", vid);
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json();
        warn("Cart add failed:", err);
        return;
      }
      const added = await res.json();
      log("Added to cart:", added);
      
      const cartIconSelectors = [
        'button.js-drawer-open-cart', 'a[data-drawer="cart"]', '.cart-link.js-drawer-open-cart',
        '#CartIcon', '[data-cart-toggle]', '.site-header__cart', '.js-mini-cart-trigger',
        'button[aria-label="Cart"]', 'a[href="/cart"] .cart-icon', '.cart-icon', '#cart-icon-bubble'
      ];
      
      let cartIcon = null;
      for (const selector of cartIconSelectors) {
        cartIcon = document.querySelector(selector);
        if (cartIcon) break;
      }
      if (cartIcon && typeof cartIcon.click === "function") cartIcon.click();
      
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("cart:change", { bubbles: true }));
      document.dispatchEvent(new CustomEvent("ajaxCart:afterCartLoad", { bubbles: true }));
      
      const drawerSelectors = ['#CartDrawer', '.js-cart-drawer', '.drawer--cart', '#mini-cart', '.mini-cart'];
      for (const selector of drawerSelectors) {
        const drawer = document.querySelector(selector);
        if (drawer) {
          drawer.classList.add('is-open', 'open', 'visible', 'active');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.classList.add('drawer-open', 'cart-drawer-open');
          break;
        }
      }
      
      if (window.jQuery) {
        window.jQuery(document).trigger('ajaxCart.afterCartLoad');
        window.jQuery(document).trigger('cart:updated');
      }
      
      if (window.theme && window.theme.cart && typeof window.theme.cart.openDrawer === "function") {
        window.theme.cart.openDrawer();
      } else if (window.theme && window.theme.cart && typeof window.theme.cart.open === "function") {
        window.theme.cart.open();
      }
      
    } catch(err) {
      warn("ATC error:", err);
    } finally {
      btn.disabled = false;
    }
  });

  // INIT
  window.addEventListener("load", () => {
    if (cfg.infiniteLoop) {
      setupInfinite(circleTrack, "circle");
      if (isMobile()) setupInfinite(prodTrack, "prod");
    }
    startCircleScroll();
    startProdScroll();
    initProgressBar();
  });

});